import React from 'react';
import clsx from 'clsx';

import styles from './hx.module.css';

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';

export type HxProps = React.HTMLAttributes<HTMLHeadingElement> & {
  /** the h level */
  headingLevel?: HeadingLevel;
  /** style the title with other level styling */
  styleLevel?: HeadingLevel | 'inherit';
}

export const Hx: React.FC<HxProps> = ({ headingLevel = 'h1', styleLevel, children, className, ...props }) => {
  return React.createElement(headingLevel, {className: clsx(styles[styleLevel || headingLevel], className), ...props}, children);
};